enum LoadingBlockerType {
    Show = "loading-blocker/SHOW",
    Hide = "loading-blocker/HIDE",
}

export default LoadingBlockerType;
